// extracted by mini-css-extract-plugin
export var columnsCard = "furtherReadingLinks-module--columnsCard--XmPeS";
export var columnsRow = "furtherReadingLinks-module--columnsRow--ie3YX";
export var fRHeader = "furtherReadingLinks-module--fRHeader--A2fjt";
export var fontsLoading = "furtherReadingLinks-module--fonts-loading--gCe0J";
export var greyBack = "furtherReadingLinks-module--greyBack--YWkY-";
export var h4 = "furtherReadingLinks-module--h4--pQUQH";
export var image = "furtherReadingLinks-module--image--OwZ8m";
export var imageWrapper = "furtherReadingLinks-module--imageWrapper--kTDO8";
export var readMore = "furtherReadingLinks-module--readMore---XM43";
export var subtitle = "furtherReadingLinks-module--subtitle--QF54c";
export var title = "furtherReadingLinks-module--title--NwLkd";
export var triangle = "furtherReadingLinks-module--triangle--EL7hq";
export var whiteBack = "furtherReadingLinks-module--whiteBack--k2KcL";
export var wrapper = "furtherReadingLinks-module--wrapper--FBG1-";